import axios from 'axios';
import { URLEndpoints } from '../../constants/urlConstants';
const BASE_URL = process.env.REACT_APP_NODEJS_SERVER_URL


export const fetchAddressList = async (id) => {
    try {
        const res = await axios.get(`${BASE_URL}/${URLEndpoints.address}`)
        console.log(res)
        return res?.data
    } catch (error) {
        console.log(error)
        return Promise.reject(error)

    }
}

export const fetchCustomerAddresses = async (customerId) => {
    if (!customerId) return [];
    const { data } = await axios.get(`${BASE_URL}/customers/${customerId}/addresses`);
    return data || [];
  };